/**
 * Production lead time — the single source of truth for every customer-facing
 * surface that quotes a turnaround (#1015).
 *
 * The lead time is a commitment we make to a customer at the moment they decide,
 * and it is quoted in more than one place (quote panel, FAQ, product copy). Each
 * surface composes its own sentence from the values below; none of them holds its
 * own literal, so the number cannot drift between where it is promised and where
 * it is planned against.
 */

/** Business days from design approval to a cut, shippable insert. */
export const LEAD_TIME_BUSINESS_DAYS = { min: 3, max: 5 } as const;

/** The shared phrase — e.g. "3-5 business days". */
export const LEAD_TIME_BUSINESS_DAYS_TEXT =
  `${LEAD_TIME_BUSINESS_DAYS.min}-${LEAD_TIME_BUSINESS_DAYS.max} business days`;

/** One-line lead-time surface for the quote panel, beside the estimate. */
export const QUOTE_LEAD_TIME_LINE =
  `Typical production lead time: ${LEAD_TIME_BUSINESS_DAYS_TEXT}.`;
